module.exports = __webpack_public_path__ + "img/santoto.2ed6ece4.png";